<template>
    <v-container>
        <v-row text-center wrap>
             <v-col>
                <v-card>
                    <v-toolbar flat class="grey lighten-4">
                        <v-toolbar-title>Компании</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="createCompanyPopup"
                            color="success"
                        >
                            Добавить
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row class="ma-0 pa-0">
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-select
                                        v-model="search.filter.status_id"
                                        @change="searchCompanies"
                                        :items="status.data"
                                        :cache-items="true"
                                        item-text="name"
                                        item-value="id"
                                        label="Статус"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-select
                                        v-model="search.filter.manager_id"
                                        @change="searchCompanies"
                                        :items="manager.search.data"
                                        :cache-items="true"
                                        clearable
                                        item-text="name"
                                        item-value="id"
                                        label="Администратор"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-text-field
                                        v-model="search.filter.name"
                                        @change="searchCompanies"
                                        name="name"
                                        label="Название компании"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-text-field
                                        v-model="search.filter.manager_email"
                                        @change="searchCompanies"
                                        name="manager_email"
                                        label="Почта"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-text-field
                                        v-model="search.filter.manager_name"
                                        @change="searchCompanies"
                                        name="manager_name"
                                        label="ФИО"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                                <v-col xs="12" sm="6" md="4" cols="4">
                                    <v-text-field
                                        v-model="search.filter.manager_phone"
                                        @change="searchCompanies"
                                        name="manager_phone"
                                        label="Телефон"
                                        class="pt-0 mt-0 mb-0"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-data-table
                            :headers="search.headers"
                            :items="filtered"
                            :loading="search.loading"
                            :footer-props="{
                                'items-per-page-options': [10, 25, 50, 100]
                            }"
                            :items-per-page="100"
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.id }}</td>
                                    <td class="text-left">{{ item.name }}</td>
                                    <td class="text-left">
                                        <span
                                            v-if="item.allow && $moment(item.from_date + ' ' + item.from_time).isBefore($moment())"
                                            class="success--text"
                                        >
                                            Активная до {{ $moment(item.till_date).format('DD.MM.YYYY') }} {{ item.till_time }}
                                        </span>
                                        <span
                                            v-if="item.allow && !$moment(item.from_date + ' ' + item.from_time).isBefore($moment())"
                                            class="warning--text"
                                        >
                                            Активная до {{ $moment(item.till_date).format('DD.MM.YYYY') }} {{ item.till_time }}
                                        </span>
                                        <span
                                            v-if="!item.allow"
                                            class="error--text"
                                        >
                                            Заблокирована
                                        </span>
                                    </td>
                                    <td class="text-left">{{ item.contact_basic_limit }} <span v-if="item.contact_extra_limit > 0">+ {{ item.contact_extra_limit }}</span></td>
                                    <td class="text-left">{{ $moment(item.till_date).diff($moment(), 'days') }}</td>
                                    <td class="text-left">
                                        <div class="d-inline-flex align-center">
                                            <router-link
                                                :to="{name: 'CompanyView', params: {id: item.id}}"
                                                class="mr-2"
                                            >
                                                <v-icon
                                                    small
                                                >
                                                    mdi-eye
                                                </v-icon>
                                            </router-link>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-if="create.show"
            v-model="create.show"
            max-width="500"
        >
            <v-card>
                <v-card-title class="headline">Новая компания</v-card-title>
                <v-form
                    @submit.prevent="createCompany"
                    autocomplete="off"
                >
                    <v-card-text>
                        <v-text-field
                            v-model="create.data.name"
                            :error-messages="create.errors.name"
                            name="name"
                            label="Название"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.person"
                            :error-messages="create.errors.person"
                            name="person"
                            label="Ф.И.О."
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.phone"
                            :error-messages="create.errors.phone"
                            name="phone"
                            label="Телефон"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.email"
                            :error-messages="create.errors.email"
                            name="email"
                            label="Почта"
                            type="text">
                        </v-text-field>
                        <v-text-field
                            v-model="create.data.password"
                            :error-messages="create.errors.password"
                            name="password"
                            label="Пароль"
                            type="text">
                        </v-text-field>
                        <v-select
                            v-model="create.data.manager_id"
                            :error-messages="create.errors.manager_id"
                            :items="manager.search.data"
                            :cache-items="true"
                            item-text="name"
                            item-value="id"
                            label="Администратор"
                        >
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="create.show = false"
                            :disabled="create.progress"
                            text
                            color="error"
                        >
                            Отменить
                        </v-btn>
                        <v-btn
                            :loading="create.progress"
                            type="submit"
                            color="primary"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "CompanyController",
    data () {
        return {
            create: {
                data: {
                    email: '',
                    manager_id: 0,
                    name: '',
                    password: '',
                    person: '',
                    phone: '',
                },
                errors: {
                    email: '',
                    manager_id: '',
                    name: '',
                    password: '',
                    person: '',
                    phone: '',
                },
                progress: false,
                show: false,
            },
            manager: {
                search: {
                    data: [],
                    loading: true,
                },
            },
            search: {
                data: [],
                filter: {
                    name: '',
                    manager_email: '',
                    manager_id: '',
                    manager_name: '',
                    manager_phone: '',
                    status_id: '',
                },
                headers: [
                    {
                        text: 'ID',
                        value: 'id',
                    },
                    {
                        text: 'Название',
                        value: 'Имя',
                    },
                    {
                        text: 'Статус',
                        value: 'email',
                    },
                    {
                        text: 'Осталось контактов',
                        value: 'contact_basic_limit',
                    },
                    {
                        text: 'Дней до блокировки',
                        value: 'till_date',
                    },
                    {
                        text: 'Действия',
                        value: 'id',
                    },
                ],
                loading: true,
            },
            status: {
                data: [
                    {
                        id: '',
                        name: 'Все компании',
                    },
                    {
                        id: 'active',
                        name: 'Активные',
                    },
                    {
                        id: 'inactive',
                        name: 'Неактивные',
                    },
                ],
            },
        }
    },
    computed: {
        filtered () {
            let data = this.search.data

            if (this.search.filter.status_id === 'active') {
                data = data.filter(c => {return c.allow})
            } else if (this.search.filter.status_id === 'inactive') {
                data = data.filter(c => {return !c.allow})
            }

            if (this.search.filter.manager_id) {
                data = data.filter(c => {return c.manager_id === this.search.filter.manager_id})
            }

            if (this.search.filter.name.length > 0) {
                data = data.filter(c => {return c.name.toLowerCase().includes(this.search.filter.name.toLowerCase())})
            }

            if (this.search.filter.manager_email.length > 0) {
                data = data.filter(c => {
                    return c.users.filter(u => {return u.email.toLowerCase().includes(this.search.filter.manager_email.toLowerCase())}).length > 0
                })
            }

            if (this.search.filter.manager_name.length > 0) {
                data = data.filter(c => {
                    return c.users.filter(u => {return u.name.toLowerCase().includes(this.search.filter.manager_name.toLowerCase())}).length > 0
                })
            }

            if (this.search.filter.manager_phone.length > 0) {
                data = data.filter(c => {
                    return c.users.filter(u => {return u.phone.replace(/\D/g, '').includes(this.search.filter.manager_phone.replace(/\D/g, ''))}).length > 0
                })
            }

            return data
        },
    },
    created () {
        this.searchCompanies()
        this.searchManagers()
    },
    methods: {
        createCompany () {
            this.create.progress = true

            this.create.errors.manager_id = []
            this.create.errors.email = []
            this.create.errors.name = []
            this.create.errors.password = []
            this.create.errors.person = []
            this.create.errors.phone = []

            this.$axios.post('/manager/company/create', this.create.data)
                .then((res) => {
                    if (res.data.success) {
                        this.create.show = false
                        this.create.data.manager_id = 0
                        this.create.data.email = ''
                        this.create.data.name = ''
                        this.create.data.password = ''
                        this.create.data.person = ''
                        this.create.data.phone = ''
                    } else {
                        this.create.errors.manager_id = res.data.errors.manager_id || []
                        this.create.errors.email = res.data.errors.email || []
                        this.create.errors.name = res.data.errors.name || []
                        this.create.errors.password = res.data.errors.password || []
                        this.create.errors.person = res.data.errors.person || []
                        this.create.errors.phone = res.data.errors.phone || []
                    }

                    this.create.progress = false

                    this.searchCompanies()
                })
                .catch(() => {
                    this.create.progress = false
                })
        },

        createCompanyPopup: function () {
            this.create.show = true
        },

        searchCompanies () {
            this.search.loading = true

            this.$axios.post('/manager/company/search')
                .then(res => {
                    if (res.data.success) {
                        this.search.data = res.data.data
                    }

                    this.search.loading = false
                })
                .catch(() => {
                    this.search.loading = false
                })
        },

        searchManagers () {
            this.manager.search.loading = true

            this.$axios.post('/manager/user/search')
                .then(res => {
                    if (res.data.success) {
                        this.manager.search.data = res.data.data.filter(m => {return m.manager})
                    }

                    this.manager.search.loading = false
                })
                .catch(() => {
                    this.manager.search.loading = false
                })
        },
    },
}
</script>

<style>
a {
    text-decoration: none;
}
</style>
